// import { request } from '@umijs/max';
import {nanoid} from "nanoid";
import { ReportOutlineRes} from "@/pages/diagnosis/type";

/** 获取报告大纲 */
export const getReportOutline: Promise<ReportOutlineRes> = (data?: any) => {
  // return request('/calendar/v4/calendars/calendar_id/events', {
  //   method: 'POST',
  //   data: {
  //     ...data,
  //   },
  //   ...(options || {}),
  // });
  console.log(data)
  const treeData: any = [
    {
      key:  nanoid(),
      href: '#no1',
      title: '诊断说明',
      children: [
        {
          key:  nanoid(),
          href: '#no1-1',
          title: '诊断流程说明',
        },
        {
          key:  nanoid(),
          href: '#no1-2',
          title: '诊断逻辑说明/诊断方法说明',
        },
        {
          key:  nanoid(),
          href: '#no1-3',
          title: '诊断评估方法说明',
        },
      ],
    },
    {
      key:  nanoid(),
      href: '#no2',
      title: '诊断总览',
      children: [
        {
          key:  nanoid(),
          href: '#no2-1',
          title: '总体评价',
        },
        {
          key:  nanoid(),
          href: '#no2-2',
          title: '问题汇总',
        },
        {
          key:  nanoid(),
          href: '#no2-3',
          title: '提升建议',
        },
      ],
    },
    {
      key:  nanoid(),
      href: '#no3',
      title: '诊断详情',
      children: [
        {
          key:  nanoid(),
          href: '#no3-1',
          title: 'Playbook',
        },
        {
          key:  nanoid(),
          href: '#no3-2',
          title: '客户管理',
        },
        {
          key:  nanoid(),
          href: '#no3-3',
          title: '商机管理',
        },
        {
          key:  nanoid(),
          href: '#no3-4',
          title: '业务风险管理',
        },
        {
          key:  nanoid(),
          href: '#no3-5',
          title: '业务审批与流程管理',
        },
      ],
    },
    {
      key:  nanoid(),
      href: '#no4',
      title: '操作行为管理',
    },
    {
      key:  nanoid(),
      href: '#no5',
      title: '附件',
      children: [
        {
          key:  nanoid(),
          href: '#no5-1',
          title: '附件一：诊断实施计划',
        },
        {
          key:  nanoid(),
          href: '#no5-2',
          title: '附件二：诊断数据来源',
        },
      ]
    },
  ];

  const temData = {
    code: 0,
    msg: 'success',
    data: {
      records: [...treeData],
    },
  };
  return Promise.resolve(temData);
};
